export default class PopIn {
    /**
     * @description Popin class constructor.
     * @param {HTMLElement} domElement - Element which contains Pop-In.
     */
    constructor(domElement) {
        // Check if element is undefined
        if(!domElement) {
            throw new Error('element is undefined');
        }

        this.domPopIn = domElement;
        this.openButton = this.domPopIn.querySelector('[data-pop-in-open-cta]');
        this.closeButton = this.domPopIn.querySelector('[data-pop-in-close-cta]');
        this.modalContainer = this.domPopIn.querySelector('[data-pop-in-container]');

        this.state = {
            focusIndex: 0,
            popInIsOpen: false,
            scrollIsActive: true
        };

        this.registerListeners();
    }

    registerListeners() {
        const toggleModal = this.togglePopInModal.bind(this);
        this.openButton.addEventListener('click', toggleModal);
        this.closeButton.addEventListener('click', toggleModal);
        this.modalContainer.addEventListener('click', event => {
            if(!event.target.closest('[data-pop-in-modal]')) {
                toggleModal(event);
            }
        });
        this.modalContainer.addEventListener('keydown', this.handleKeydown.bind(this));
    }

    /**
     * @description Change the value of a state.
     * @param {object} value - Value to store in state.
     * @param {boolean} isToRender - True to make a render.
     */
    setState(value, isToRender = true) {
        this.state = {...this.state, ...value};
        if(isToRender) {
            this.render();
        }
    }

    render() {
        this.updateModal();
    }

    updateModal() {
        this.modalContainer.dataset.openPopIn = this.state.popInIsOpen;
        document.body.style.overflow = this.state.scrollIsActive ? 'auto' : 'hidden';
    }

    togglePopInModal(event) {
        event.stopPropagation();
        this.setState({
            popInIsOpen: !this.state.popInIsOpen,
            scrollIsActive: !this.state.scrollIsActive
        });
        this.state.popInIsOpen ? this.addAccessibility() : this.removeAccessibility();
    }

    addAccessibility() {
        this.modalContainer.setAttribute('aria-hidden', 'false');
        this.modalContainer.setAttribute('tabindex', '0');
        const focusableElementSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]';
        this.domFocusableElements = [...this.modalContainer.querySelectorAll(focusableElementSelector)];
        const [domFirstFocusableElement] = this.domFocusableElements;
        domFirstFocusableElement.focus();
    }

    removeAccessibility() {
        this.modalContainer.setAttribute('aria-hidden', 'true');
        this.modalContainer.removeAttribute('tabindex');
        this.modalContainer.removeEventListener('keydown', this.handleKeydown.bind(this));
        this.openButton.focus();
    }

    handleKeydown(event) {
        switch (event.code) {
            case 'Tab':
                this.handleTabEvent(event);
                break;
            case 'Escape':
                this.togglePopInModal(event);
                break;
            default:
                break;
        }
    }

    handleTabEvent(event) {
        event.preventDefault();

        const [domFirstFocusableElement] = this.domFocusableElements;
        const domLastFocusableElement = this.domFocusableElements[this.domFocusableElements.length - 1];

        if(!domFirstFocusableElement && !domLastFocusableElement) {
            return;
        }

        this.doFocus(event.shiftKey);
    }

    doFocus(reverseNavigation) {
        const offset = reverseNavigation ? -1 : 1;
        const newFocusIndex = (this.state.focusIndex + offset) % this.domFocusableElements.length;
        this.updateFocusIndex(newFocusIndex);
        PopIn.focusDomElement(this.domFocusableElements[newFocusIndex]);
    }

    updateFocusIndex(index) {
        this.setState({
            focusIndex: index
        }, false);
    }

    static focusDomElement(domElement) {
        window.setTimeout(() => {
            domElement.focus();
        }, 300);
    }
}
